import React from "react";
import "./section_header.scss";
const SectionHeader = ({ name }) => {
  return (
    <div
      className="section_header_main"
      style={{ margin: name !== "HOME" ? "1rem 1rem" : "0" }}
    >
      <div className="section_head">
        <h6>{name}</h6>
      </div>
    </div>
  );
};

export default SectionHeader;
